import standardAPI from '@/api/standard_items';

const state = {
  excursions: [],
  excursions_status: '',
  excursions_MetaData: {},
  excursions_page: 1,
  excursions_perPage: 10,
};

const responseUrl = '/world-tours/excursions';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_excursions ({ commit }, getOptions) {
    commit('EXCURSIONS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('EXCURSIONS_SUCCESS', response);
            commit('EXCURSIONS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('EXCURSIONS_READY');
            reject(response);
          } else {
            commit('EXCURSIONS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  fetch_excursions_silent ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            resolve(response);
          } else if (response.status === 404) {
            reject(response);
          } else {
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_excursion ({ commit, dispatch }, itemData) {
    commit('EXCURSIONS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('EXCURSIONS_READY');
          reject(response);
        }
      });
    });
  },
  edit_excursion ({ commit, dispatch }, itemData) {
    commit('EXCURSIONS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          commit('EXCURSIONS_READY');
          reject(response);
        }
      });
    });
  },
  remove_excursion ({ commit, dispatch }, itemData) {
    commit('EXCURSIONS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          resolve(response);
        } else {
          commit('EXCURSIONS_READY');
          reject(response);
        }
      });
    });
  },
  reorder_excursion ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  set_excursion_order ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/set-reorder-index/' + itemData.id,
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item_number(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.excursions_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.excursions_perPage = max;
  },
  EXCURSIONS_READY: (state) => {
    state.excursions_status = 'ready';
  },
  EXCURSIONS_REQUEST: (state) => {
    state.excursions_status = 'loading';
  },
  EXCURSIONS_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.excursions_MetaData.meta = response.meta;
      state.excursions_MetaData.links = response.links;
    }
    if (response && response.data) {
      state.excursions = response.data.map((excursion) => {
        excursion.checked = false; // need for some pages where we can select excursions
        return excursion;
      }) || [];
    }
    state.excursions_status = 'success';
  },
  EXCURSIONS_ERROR: (state) => {
    state.excursions_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
